import { useState } from "react";
import { ShieldAlert, LogOut, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function MasqueradeBanner() {
  const { user } = useAuth();
  const [exiting, setExiting] = useState(false);
  const masq = user?.masqueraded_by;
  if (!masq) return null;

  const exit = async () => {
    setExiting(true);
    try { await api.post("/auth/masquerade/stop"); } catch { /* ignore */ }
    window.location.href = "/dashboard";
  };

  return (
    <div data-testid="masquerade-banner" className="flex items-center justify-between gap-3 border-b border-amber-300 bg-amber-100 px-4 py-2 text-amber-900 dark:border-amber-500/60 dark:bg-amber-500/20 dark:text-amber-50 md:px-6">
      <div className="flex min-w-0 items-center gap-2 text-sm">
        <ShieldAlert className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-300" />
        <span className="truncate">
          <span className="font-semibold">{masq.name}</span>, you're viewing as <span className="font-semibold">{user.name}</span>
          <span className="hidden sm:inline"> ({user.role_label || user.base_role}). All actions are recorded.</span>
        </span>
      </div>
      <button data-testid="masquerade-exit-button" onClick={exit} disabled={exiting}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-md border border-amber-400 bg-white/70 px-2.5 py-1 text-xs font-semibold text-amber-900 transition-colors hover:bg-white dark:border-amber-400/70 dark:bg-amber-950/60 dark:text-amber-50 dark:hover:bg-amber-900/70 disabled:opacity-60">
        {exiting ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <LogOut className="h-3.5 w-3.5" />} Exit masquerade
      </button>
    </div>
  );
}
